import { render, staticRenderFns } from "./AverageProcessingTimeView.vue?vue&type=template&id=688dc54f&"
import script from "./AverageProcessingTimeView.vue?vue&type=script&lang=ts&"
export * from "./AverageProcessingTimeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports